<template>
  <div>
    <v-card class="mx-4 mt-6" shaped elevation="12" max-width="344" outlined>
      <v-list-item three-line>
        <v-autocomplete
          class="my-4"
          chips
          clearable
          deletable-chips
          filled
          rounded
          small-chips
          solo
          solo-inverted
          v-model="selectedTable"
          label="Select Table"
          :items="tables"
          @change="getSelectedTable()"
        ></v-autocomplete>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-database-tables", this.getAccessToken)
      .then((tables) => {
        this.tables = [];
        tables.forEach((table) => {
          this.tables.push({
            text: this.formatTableName(table.name),
            value: table.name,
          });
        });

        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    selectedTable: null,
    tables: [],
  }),
  methods: {
    getSelectedTable() {
      this.$emit("table-selected", this.selectedTable);
    },
    formatTableName(tableName) {
      let table = "";
      if (tableName && tableName.includes("_")) {
        table = tableName.replace("_", " ");
      } else {
        table = tableName;
      }

      table = table.split(" ");
      if (table.length > 1) {
        let parts = "";
        table.forEach((tab) => {
          parts += tab.toUpperCase() + " ";
        });
        table = parts;
      } else {
        table = table[0].toUpperCase();
      }
      return table;
    },
  },
};
</script>

<style></style>
